import React from 'react';
import ipEmptyImage from '../assets/images/ip-empty.png';

export interface CustomEmptyProps {
  description?: React.ReactNode;
  style?: React.CSSProperties;
  /** 自定义图片，传入 import 的图片资源 */
  image?: string;
}

export const CustomEmpty: React.FC<CustomEmptyProps> = ({ description, style, image }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 0',
        ...style,
      }}
    >
      <img
        src={image || ipEmptyImage}
        alt="empty"
        style={{ height: 160, marginBottom: 16 }}
      />
      {description && (
        <div style={{ color: 'var(--ant-color-text-secondary)', fontSize: 14 }}>
          {description}
        </div>
      )}
    </div>
  );
};
